function spinnerstart(e) {
    var t = $('<div class="veil"><div class="underlay"></div></div>');
    t.append('<div class="spinner" role="alert" aria-live="polite" aria-atomic="true"><span class="sr-only">Loading...</span><div class="dot1"></div><div class="dot2"></div></div>');
    if ("IMG" === e.get(0).tagName) {
        e.after(t);
        t.css({ width: e.width(), height: e.height() });
        if ("static" === e.parent().css("position")) {
            e.parent().css("position", "relative");
        }
    } else {
        e.append(t);
        if ("static" === e.css("position")) {
            e.parent().css("position", "relative");
            e.parent().addClass("veiled");
        }
        if ("BODY" === e.get(0).tagName) {
            t.find(".spinner").css("position", "fixed");
        }
    }
    t.click(function (e) {
        e.stopPropagation();
    });
}
function spinnerstop(e) {
    if (e.parent().hasClass("veiled")) {
        e.parent().css("position", "");
        e.parent().removeClass("veiled");
    }
    e.off("click");
    e.remove();
}

$.fn.spinner = function () {
    var o = $(this);
    return new (function () {
        (this.start = function () {
            o.length && spinnerstart(o);
        }),
            (this.stop = function () {
                o.length && spinnerstop($(".veil"));
            });
    })();
};

$.spinner = function () {
    return new (function () {
        (this.start = function () {
            spinnerstart($("body"));
        }),
            (this.stop = function () {
                spinnerstop($(".veil"));
            });
    })();
};

function n(e) {
    return (
        (n =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                      return typeof e;
                  }
                : function (e) {
                      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                  }),
        n(e)
    );
}

var r = {
    publish: function (e, o) {
        t[e] &&
            t[e].forEach(function (e) {
                return e(o);
            });
    },
    subscribe: function (e, o) {
        var n;
        return (
            t[e] || (t[e] = []),
            (n = t[e].push(o) - 1),
            {
                unsubscribe: function () {
                    t[e].splice(n, 1);
                },
            }
        );
    },
};

$.fn.Flyout = function (e, t) {
    var o,
        a,
        i,
        c,
        p,
        s,
        b,
        l = this,
        M = "",
        d = $.extend(
            {
                id: "flyout",
                showOverlay: !0,
                showLogo: !0,
                changeIds: !1,
                destroyOnClose: !1,
                closeAriaLabel: "close button",
                content: { type: "string", copyType: "append", src: "", ajaxMethod: "get" },
                position: [
                    { breakpoint: "sm", position: "right", size: "80%" },
                    { breakpoint: "lg", position: "top", size: "60%" },
                ],
            },
            e
        );
    d.content && !d.content.copyType && (d.content.copyType = "append");
    var z = {};
    $(window).on("resize", function () {
        o && o.hasClass("open") && window.innerWidth > 1024 && window.innerWidth < 1200 && u();
    });
    var u = function () {
            if (d.destroyOnClose) {
                o.remove();
                o = null;
            } else {
                d.onClose && d.onClose(c);
                o.removeClass("open open--with-overlay");
                o.removeAttr("style");
                a.removeClass("top bottom right left").removeAttr("style");
            }
            $(document).trigger("flyout.closed");
            $("body").css("overflow-y", "auto");
            M && M.focus();
            $("#nextActionNeeded").val("");
            $("#similar-flyout").val("");
            $(".cannot-fullfill-notification").addClass("d-none");
            p.disconnect();
        },
        O = !0,
        f = function () {
            h();
            var e = o[0];
            (p = new MutationObserver(function () {
                if (O) {
                    setTimeout(function () {
                        return h();
                    }, 100);
                    setTimeout(function () {
                        return m();
                    }, 100);
                    O = false;
                }
            })).observe(e, { attributes: !0, childList: !0, subtree: !0 });
        },
        A = function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            d.changeIds && y();
            d.onComplete && d.onComplete(c, e, M);
        },
        m = function () {
            if (o) {
                var e,
                    t,
                    n = document.getElementById(o[0].id),
                    r = n.querySelector('[aria-modal="true"]');
                if (r) {
                    if ("searchFlyout" === n.id) return void r.setAttribute("aria-label", "Search");
                    if ("storeFlyout" === n.id) return r.setAttribute("aria-label", "Store Flyout"), void n.setAttribute("data-qa-id", "store-flyout");
                    for (var a = n.querySelectorAll(".heading:not([disabled])"), i = r.getAttribute("aria-labelledby"), c = null, p = 0; p < a.length; p += 1)
                        a[p].hasAttribute("id") && ((e = a[p]), (t = void 0), (t = e.getBoundingClientRect()).x || t.y || t.width || t.height) && (c = a[p].getAttribute("id")) !== i && r.setAttribute("aria-labelledby", c);
                }
            }
        },
        h = function () {
            if (o) {
                for (var e = a[0].querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'), t = [], n = 0; n < e.length; n += 1) {
                    var r = e[n].getBoundingClientRect();
                    (r.x || r.y || r.width || r.height) && t.push(e[n]);
                }
                if (0 !== t.length) {
                    var i = b;
                    s && (s.removeEventListener("keydown", z.firstElement), delete z.firstElement),
                        i && (i.removeEventListener("keydown", z.lastElement), delete z.lastElement),
                        (s = t[0]),
                        (b = t[t.length - 1]),
                        t.includes(document.activeElement) || s.focus(),
                        q(s, "Tab", t[1], "shiftKey", b, "firstElement"),
                        q(b, "Tab", s, "shiftKey", t[t.length - 2], "lastElement"),
                        (O = !0);
                }
            }
        },
        q = function (e, t, o, n, r, a) {
            if (!z[a]) {
                z[a] = function (a) {
                    if (a.code === t) {
                        a.preventDefault();
                        if (a[n]) {
                            r.focus();
                        } else {
                            o.focus();
                        }
                    } else if (a.code === "Enter") {
                        a.preventDefault();
                        e.click();
                    }
                };
            }

            e.addEventListener("keydown", z[a], false);
        },
        y = function () {
            c.find("[id]").each(function () {
                var $element = $(this);
                var oldId = $element.attr("id");
                var newId = oldId + "_flyout";

                $element.attr("id", newId);

                c.find('[for="' + oldId + '"]').attr("for", newId);
                c.find('[href="#' + oldId + '"]').attr("href", "#" + newId);
            });
        },
        v = function () {
            for (
                var e = (function () {
                        for (
                            var e = d.position.map(function (e) {
                                    return e.breakpoint;
                                }),
                                t = window.innerWidth,
                                o = [
                                    { k: 0, v: "sm" },
                                    { k: 720, v: "md" },
                                    { k: 1024, v: "lg" },
                                    { k: 1200, v: "xl" },
                                    { k: 1440, v: "xxl" },
                                ],
                                n = "sm",
                                r = 1;
                            r < o.length;
                            r += 1
                        ) {
                            var a = o[r].k,
                                i = o[r].v;
                            t >= a && e.indexOf(i) > -1 && (n = i);
                        }
                        return n;
                    })(),
                    t = "",
                    o = 0,
                    n = 0;
                n < d.position.length;
                n += 1
            ) {
                var r = d.position[n];
                if (r.breakpoint === e) {
                    (t = r.position), (o = r.size);
                    break;
                }
            }
            a.addClass(t);
            a.addClass("flyout-" + t + "-" + o);
            var c = "width";
            if (t === "top" || t === "bottom") {
                c = "height";

                if (e === "md" || e === "lg") {
                    $(i).addClass("header-wrapper");
                }
            }

            a.css(c, o);
        },
        g = function () {
            o ||
                (function () {
                    o = $("<div>");
                    o.attr("id", d.id);
                    o.addClass("flyout");

                    a = $("<div>");
                    a.attr("aria-modal", true);
                    a.attr("role", "dialog");
                    a.addClass("flyout--body");
                    var e = d.content.src;
                    i = $("<div>");
                    var t = document.createElement("img");
                    if (d.showLogo) {
                        var r = $(".logo-home > img.logo");
                        if (typeof d.showLogo == "string") {
                            r = d.showLogo;
                        }
                        if (typeof r === "string") {
                            t.setAttribute("src", r);
                            t.setAttribute("alt", "flyout logo");
                        } else if (n(r) === "object") {
                            t.setAttribute("src", r.attr("src"));
                            t.setAttribute("alt", r.attr("alt"));
                        }

                        t.classList.add("logo");
                        i.append(t);
                    }
                    var p = $('<button aria-label = "close" title="close" class="icon icon-close" data-close-fo data-qa-id="flyout-close"></button>');
                    switch ((i.addClass("flyout--heading"), (c = $('<div class="flyout--content container-full-bleed">')).on("flyout.close", u), "append" === d.content.copyType && ($("body").append(o), o.append(a), a.append(i), i.append(p), a.append(c), o.hide()), d.content.type)) {
                        case "string":
                            if (e) {
                                c.addClass("flyout--content").html(e);
                            }
                            A();
                            o.show();
                            break;
                        case "tag":
                            setTimeout(function () {
                                try {
                                    c.addClass("flyout--content");
                                    if ("append" === d.content.copyType) {
                                        $(e).removeClass("d-none");
                                        c.append($(e));
                                    }
                                    A();
                                    o.show();
                                } catch (e) {
                                    c.html("");
                                }
                            }, 500);
                            break;
                        case "url":
                            $.spinner().start();
                            var s = d.content && d.content.ajaxMethod ? d.content.ajaxMethod : "get",
                                b = e || $(M).data("url");
                            try {
                                $.ajax({
                                    method: s,
                                    url: b,
                                    beforeSend: function (e) {
                                        e.setRequestHeader("X-WP-Nonce", wpApiSettings.nonce);
                                    },
                                    success: function (e) {
                                        c.html(e);
                                        $.spinner().stop();
                                        A(e);
                                        o.show();
                                    },
                                    error: function () {
                                        c.html("couldnt load content");
                                        o.show();
                                        $.spinner().stop();
                                    },
                                });
                            } catch (e) {
                                break;
                            }
                            break;
                        case "template":
                            $.spinner().start();
                            var ajaxMethod = d.content && d.content.ajaxMethod ? d.content.ajaxMethod : "get";
                            var action = d.content && d.content.action ? d.content.action : "show_template";
                            var template = e || $(M).data("template");
                            var args = {};
                            try {
                                $.ajax({
                                    method: ajaxMethod,
                                    url: wp_goodyear.ajaxurl,
                                    data: {
                                        action: action,
                                        template: template,
                                        arguments: args,
                                        nonce: wp_goodyear.nonce,
                                    },
                                    success: function (response) {
                                        c.html(response);
                                        $.spinner().stop();
                                        A(response);
                                        o.show();
                                    },
                                    error: function () {
                                        c.html("could not load content");
                                        o.show();
                                        $.spinner().stop();
                                    },
                                });
                            } catch (e) {
                                break;
                            }
                            break;
                    }
                    a.on("click keydown", "[data-close-fo]", function (e) {
                        const isClick = e.type === "click";
                        const isKeydownWithValidKey = e.type === "keydown" && (e.code === "Enter" || e.code === "Space");

                        if (isClick || isKeydownWithValidKey) {
                            setTimeout(u, 500);
                        }
                    });

                    o.on("click", function (e) {
                        if (e.target === e.currentTarget) {
                            u();
                        }
                    });

                    $(document).on("keydown", function (e) {
                        if (e.code === "Escape" && o && o.hasClass("open")) {
                            u();
                        }
                    });
                })();
            d.onOpen && d.onOpen(c, M);
            d.showOverlay ? o.addClass("open open--with-overlay") : o.addClass("open");
            d.zindex && o.css("z-index", d.zindex);
            a.find(".icon-close").focus();
            v();
            $(document).trigger("flyout.opened");
            d.showOverlay && $("body").css("overflow-y", "hidden");
            $(document).find("#quickViewWrapper") && $(document).find("#quickViewWrapper").length && $("body").trigger("show-QuickView");
        };
    if (t && t === "document") {
        g();
    } else {
        if (t) {
            $("body").on("click keydown", t, function (e) {
                W(e);
            });
        } else {
            l.on("click keydown", function (e) {
                W(e);
            });
        }

        if (l.find("#find-tire-btn").length) {
            $("#find-tire-btn").removeAttr("aria-haspopup");
        }

        l.attr("aria-haspopup", "dialog");
    }
    var W = function (e) {
        if (("keydown" === e.type && ("Enter" === e.code || "Space" === e.code)) || "click" === e.type) {
            e.preventDefault();
            var t = e.currentTarget,
                o = "a, button, [href]";
            if ($(t).is(o)) {
                M = t;
            } else {
                M = $(t).children(o)[0];
            }

            g();
        }
    };
    return this;
};
